// Module
var code = `<!-- ko using: model -->
<!-- ko if: isToolboxVisible -->
<!-- ko component: { name: 'svc-toolbox', params: { model: creator }} -->
<!-- /ko -->
<!-- /ko -->
<div class="svc-tab-designer" data-bind="css: getRootCss(), click: clickDesigner">
  <!-- ko component: { name: 'svc-scroll' } -->
  <div class="svc-tab-designer_content">
    <!-- ko if: showPlaceholder -->
    <!-- ko if: (creator.showHeaderInEmptySurvey && creator.allowEditSurveyTitle) -->
    <div class="svc-designer-header">
      <!-- ko template: { name: 'survey-header', data: survey } -->
      <!-- /ko -->
    </div>
    <!-- /ko -->
    <div class="svc-designer__placeholder-container" data-bind="attr: { 'data-sv-drop-target-survey-element': 'newGhostPage' }">
      <!-- ko component: { name: 'svc-surface-placeholder', params: { name: 'designer', placeholderTitleText: \$data.placeholderTitleText, placeholderDescriptionText: \$data.placeholderDescriptionText } } -->
      <!-- /ko -->
      <svc-page class="svc-designer-placeholder-page" params="survey: survey, creator: creator, page: newPage, isGhost: true">
      </svc-page>
    </div>
    <!-- /ko -->

    <!-- ko if: !showPlaceholder -->

    <div data-bind="css: designerCss, style:{maxWidth: survey.renderedWidth}, creatorStyle: surveyThemeVariables">
      <!-- ko if: creator.allowEditSurveyTitle -->
      <div class="svc-designer-header">
        <!-- ko template: { name: 'survey-header', data: survey } -->
        <!-- /ko -->
      </div>
      <!-- /ko -->

      <!-- ko if: false && survey.isShowProgressBarOnTop -->
      <!-- ko component: { name: survey.getProgressTypeComponent(), params: { model: survey } } -->
      <!-- /ko -->
      <!-- /ko -->

      <!-- ko ifnot: creator.pageEditMode === 'bypage' -->
      <!-- ko foreach: survey.pages -->
      <svc-page class="svc-page" data-bind="attr: { 'data-sv-drop-target-survey-element': \$data.name, 'data-sv-drop-target-page': \$data.name }" params="survey: \$parent.survey, page: \$data, creator: \$parent.creator, isGhost: false"></svc-page>
      <!-- /ko -->
      <!-- ko if: showNewPage -->
      <svc-page class="svc-page" data-bind="attr: { 'data-sv-drop-target-survey-element': 'newGhostPage' }" params="survey: survey, creator: creator, page: newPage, isGhost: true"></svc-page>
      <!-- /ko -->
      <!-- /ko -->

      <!-- ko if: pagesController.page2Display && creator.pageEditMode === 'bypage' -->
      <svc-page class="svc-page" data-bind="attr: { 'data-sv-drop-target-survey-element': displayPageDropTarget, 'data-sv-drop-target-page': pagesController.page2Display.name }" params="survey: survey, page: pagesController.page2Display, creator: creator, isGhost: pagesController.page2Display == newPage"></svc-page>
      <!-- /ko -->

      <!-- ko if: false && survey.isShowProgressBarOnBottom -->
      <!-- ko component: { name: survey.getProgressTypeComponent(), params: { model: survey } } -->
      <!-- /ko -->
      <!-- /ko -->
    </div>

    <!-- ko if: showSurfaceTools -->
    <div class="svc-tab-designer__tools">
      <!-- ko if: creator.showPageNavigator -->
      <div class="svc-tab-designer__page-navigator">
        <svc-page-navigator params="controller: pagesController, pageEditMode: creator.pageEditMode">
        </svc-page-navigator>
      </div>
      <!-- /ko -->
      <!-- ko if: showSurfaceToolbar -->
      <div class="svc-tab-designer__toolbar">
        <!-- ko component: { name: 'sv-action-bar', params: { model: surfaceToolbar, handleClick: false } } -->
        <!-- /ko -->
      </div>
      <!-- /ko -->
    </div>
    <!-- /ko -->
    <!-- /ko -->
  </div>
  <!-- /ko -->

</div>
<!-- /ko -->`;
// Exports
export default code;